import { Stack, Typography } from '@mui/material'
import { SummaryElement } from './components/SummaryElement'
import { type SurveyContent } from './MidYearSummary'

interface Props {
  content: SurveyContent
  answers: Record<string, any>
}
export const RCNMidYearSummary = ({ content, answers }: Props): JSX.Element => {
  return (<>
    <Typography variant='h3'>
      RCN Operations
    </Typography>

    {content.pages.map((page, pageIndex) => (
      <Stack key={pageIndex} gap='24px'>
        <Typography variant='h4'>{page.title}</Typography>
        {page.elements.map((element) => (
          <SummaryElement key={element.name} element={element} answers={answers} />
        ))}
      </Stack>
    ))}
  </>)
}
